module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/hall-list/plan-wedding-lineup-kyushu-2-f8efe2b89213ad41cbd14674119292f5.png";